import {
  Avatar,
  Box,
  Card,
  Grid,
  Hidden,
  Icon,
  IconButton, MenuItem,
  styled,
  useTheme,
} from '@mui/material';
import { Span } from '../../../components/Typography';
import React, { Fragment } from 'react';
import { Link } from "react-router-dom";
import { MatxMenu } from "../../../components";
import useDashboard from "../../../hooks/useDashboard";
import { useFeaturedProduct } from '../../../requests/dashboard';

const ProjectName = styled(Span)(({ theme }) => ({
  marginLeft: 24,
  fontWeight: '500',
  [theme.breakpoints.down('sm')]: { marginLeft: 4 },
}));

const StyledItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 200,
  '& a': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  '& span': { marginRight: '10px', color: theme.palette.text.primary },
}));

const StyledAvatar = styled(Avatar)(() => ({
  width: '32px !important',
  height: '32px !important',
}));

const RowCards = () => {
  const { palette } = useTheme();
  const textMuted = palette.text.secondary;
  const { remove_featured } = useDashboard();

  const { data: productList } = useFeaturedProduct();


  async function handleOnClickFeatureRemove(product_id, index) {
    await remove_featured(product_id, index);
  }


  function shopName(vendor) {
    if (!vendor) return 'N/A';

    if (typeof vendor === 'object') {
      return vendor?.shop_name;
    }
    return `N/A`
  }


  return (productList?.products || []).map((product, id) => (
    <Fragment key={id}>
      <Card sx={{ py: 1, px: 2 }} className="project-card">
        <Grid container alignItems="center">
          <Grid item md={5} xs={7}>
            <Box display="flex" alignItems="center">
              <Hidden smDown>
                <StyledAvatar src={(product?.images_new?.length > 0 ? product?.images_new[0]?.image : "")} />
              </Hidden>
              <ProjectName>{product?.product_title}</ProjectName>

            </Box>
          </Grid>

          <Grid item md={3} xs={4}>
            <Box color={textMuted}> {shopName(product?.vendor)}</Box>
          </Grid>

          <Hidden smDown>
            <Grid item xs={3}>
              <Box display="flex" position="relative" marginLeft="-0.875rem !important">
                {product?.sold_quantity} Sold
              </Box>
            </Grid>
          </Hidden>

          <Grid item xs={1}>
            <Box display="flex" justifyContent="flex-end">
              <MatxMenu
                menuButton={
                  <IconButton>
                    <Icon>more_vert</Icon>
                  </IconButton>
                }>
                <StyledItem>
                  <Link to={'/product/add/' + product.id}>
                    <Icon> edit </Icon>
                    <Span> Edit </Span>
                  </Link>
                </StyledItem>

                <StyledItem>
                  <Link to={'/product/detail/' + product.id}>
                    <Icon> remove_red_eye </Icon>
                    <Span> View </Span>
                  </Link>
                </StyledItem>

                <StyledItem onClick={() => handleOnClickFeatureRemove(product.id, id)}>
                  <Icon> do_disturb </Icon>
                  <Span> UnFeatured </Span>
                </StyledItem>

              </MatxMenu>
            </Box>
          </Grid>
        </Grid>
      </Card>
      <Box py={1} />
    </Fragment>
  ));
};

export default RowCards;
